import React from 'react';
//import {Redirect} from 'react-router';
import {
  Container,
  Header,
  Segment,
  Icon,
  Dimmer,
  Loader,
  Item,
  Button,
  Label,
  Image,
  Grid,
  Divider,
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';
import ReadMore from './ReadMore';
import Api from '../api';
import moment from 'moment';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    EmailShareButton,
  } from 'react-share';
import AgeRestriction from './AgeRestriction';

class UserPage extends React.Component {

    state = {
        profile: null,
        storys: [],
    };

    async fetchGames() {
        return await Api.Story.getAll().then((data) => data.data.stories);
    };

    async fetchCategories(id) {
        return await Api.Categories.getAll().then((data) => data.data);
    };

    componentWillUnmount(){
        this._isUnmounted = true;
    }

    async componentWillMount() {
        this._isMounted = true;
        const id = this.props.match.params.id;
        if(id){
          
            let profile = await Api.Profile.getProfileById(id).then(data => data.data.profile).catch(err => null);
            if(!profile) profile = await Api.Profile.getProfileByURLShort(id).then(data => data.data).catch(err => -1);

            if(profile && profile !== -1)
              profile.name = await Api.User.getName(profile.accountId).then(data => data.data.firstName + " " + data.data.lastName).catch(err => "");
            
            if(profile && profile !== -1) profile.image = profile.image ? await Api.Cover.getCoverFile(profile.image).then(data => data.data.signed).catch(err => null) : null;
            
            if(!this._isUnmounted){

                this.setState({profile: profile});
                let storys = await Api.Story.getStorysWithUserId(profile.accountId).then(data => data.data.storys).catch(err => []);
                
                const categories = await this.fetchCategories();
                storys.forEach(game => game.category = categories.find(cat => cat.id === game.category));

                let renderStorys = [];
                for(let i=0; i < storys.length; i++){

                  if(typeof(storys[i].authorId) !== 'string'){
                      storys[i].authorName = [];
                      for(let k = 0; k < storys[i].authorId.length; k++) storys[i].authorName.push(
                          await Api.User.getName(storys[i].authorId[k]).then(data => data.data).catch(err => null)
                      );
                  } else {
                      storys[i].authorName = await Api.User.getName(storys[i].authorId).then(data => data.data).catch(err => null);
                  }
      
                  if(typeof(storys[i].speakerId) !== 'string'){
                      storys[i].speakerName = [];
                      for(let k = 0; k < storys[i].speakerId.length; k++) storys[i].speakerName.push(
                          await Api.User.getName(storys[i].speakerId[k]).then(data => data.data).catch(err => null)
                      );
                  } else {
                      storys[i].speakerName = await Api.User.getName(storys[i].speakerId).then(data => data.data).catch(err => null);
                  }

                  storys[i].cover = await Api.Cover.getCoverFile(storys[i].cover).then(data => data.data.signed).catch(err => null);
                  storys[i].ownerName = await Api.User.getName(storys[i].ownerId).then(data => data.data).catch(err => null);
                  renderStorys.push(storys[i]);
                  if(!this._isUnmounted){
                    this.setState({storys: renderStorys});
                  }
                }
                if(!this._isUnmounted){
                  this.setState({storys: storys});
                }
            }
        }
    };

    getSocialMedia(sm){
      let ary = [];
      let index = 0;
      if (sm.facebook){
        ary.push(
          <Grid.Column key={index} textAlign='center'>
            <Button
              icon='facebook'
              color='facebook'
              size='big'
              onClick={this.handleSMClick.bind(this, 'https://www.facebook.com/' + sm.facebook)}
              />
          </Grid.Column>
        );
        index++;
      }
      if (sm.instagram){
        ary.push(
          <Grid.Column key={index} textAlign='center'>
            <Button
              icon='instagram'
              color='purple'
              size='big'
              onClick={this.handleSMClick.bind(this, 'https://www.instagram.com/' + sm.instagram)}
              />
          </Grid.Column>
        );
        index++;
      }
      if (sm.youtube){
        ary.push(
          <Grid.Column key={index} textAlign='center'>
            <Button
              icon='youtube'
              color='youtube'
              size='big'
              onClick={this.handleSMClick.bind(this, 'https://www.youtube.com/channel/' + sm.youtube)}
              />
          </Grid.Column>
        );
        index++;
      }
      if (sm.twitter){
        ary.push(
          <Grid.Column key={index} textAlign='center'>
            <Button
              icon='twitter'
              color='twitter'
              size='big'
              onClick={this.handleSMClick.bind(this, 'https://www.twitter.com/' + sm.twitter)}
              />
          </Grid.Column>
        );
        index++;
      }
      if (sm.linkedin){
        ary.push(
          <Grid.Column key={index} textAlign='center'>
            <Button
              icon='linkedin'
              color='linkedin'
              size='big'
              onClick={this.handleSMClick.bind(this, 'https://www.linkedin.com/in/' + sm.linkedin)}
              />
          </Grid.Column>
        );
        index++;
      }
      if (sm.website){
        ary.push(
          <Grid.Column key={index} textAlign='center'>
            <Button
              icon='globe'
              color='grey'
              size='big'
              onClick={this.handleSMClick.bind(this, 'https://' + sm.website)}
              />
          </Grid.Column>
        );
        index++;
      }
      
      return ary;
    }

    renderStorys(storys){
      let ary = [];
      for(let i=0; i < storys.length; i++){
        const s = storys[i];

        let authorRender = null;
        if(typeof(s.authorId) !== 'string'){
            let authors = [];
            for(let k=0; k < s.authorName.length; k++){
                authors.push(
                    <b key={k} style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.authorId[k])}>{`${s.authorName[k].firstName} ${s.authorName[k].lastName}`}</b>
                );
                if(k + 1 < s.authorName.length) authors.push(
                    <span key={k.toString() + "-&"}>&</span>
                );
            }
            authorRender = (
                <p>
                    <span>von {authors}</span><br/>
                </p>
            );
        } else {
            authorRender = (
                <p>
                    <span>von <b style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.authorId)}>{`${s.authorName.firstName} ${s.authorName.lastName}`}</b></span><br/>
                </p>
            );
        }

        let speakerRender = null;
        if(typeof(s.speakerId) !== 'string'){
            let speakers = [];
            for(let k=0; k < s.speakerName.length; k++){
                speakers.push(
                    <b key={k} style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.speakerId[k])}>{`${s.speakerName[k].firstName} ${s.speakerName[k].lastName}`}</b>
                );
                if(k + 1 < s.speakerName.length) speakers.push(
                    <span key={k.toString() + "-&"}>&</span>
                );
            }
            speakerRender = (
                <p>
                    gesprochen von {speakers}
                </p>
            );
        } else {
            speakerRender = (
                <p>
                    <span>gesprochen von <b style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.speakerId)}>{`${s.speakerName.firstName} ${s.speakerName.lastName}`}</b></span>
                </p>
            );
        }

        ary.push(
          <Item key={i}>
            <Item.Image  style={{cursor: 'pointer'}} onClick={this.onClick.bind(this, s.id)} src={s.cover} />
            <Item.Content>
              <Item.Header as='a' onClick={this.onClick.bind(this, s.id)}>{s.title}</Item.Header>
              <Item.Meta>
                <p>Veröffentlicht am {moment(s.date_published).format("DD. MMMM YYYY")}</p>
                {authorRender}
                {speakerRender}
                <Label  style={{cursor: 'pointer'}} onClick={this.toCategory.bind(this, s.category.id)}>{s.category.name}</Label>
                <AgeRestriction age={s.ageRestriction} />
              </Item.Meta>
              <Item.Description>
                <p style={{textAlign: 'justify'}}>{s.description}</p>
              </Item.Description>
              <Item.Extra>
                <Button
                  icon
                  color='green'
                  labelPosition='right'
                  floated='right'
                  onClick={this.onClick.bind(this, s.id)}
                  >
                  Hören
                  <Icon name='play' />
                </Button>
              </Item.Extra>
            </Item.Content>
          </Item>
        );
      }
      return ary;
    }

    handleSMClick(url){
      const win = window.open(url, '_blank');
      win.focus();
    }

    toCategory(id){
      window.scrollTo(0,0);
      this.props.history.push('/category/'+id);
    }

    onClick(id){
      /*
        window.dataLayer.push({
            event: 'onWebsiteEvent',
            eventCategory: 'userSite_'+this.state.profile.urlShort,
            eventAction: 'playProject',
            eventLabel: 'clickPlay',
            eventValue: id
        });
        */
        window.scrollTo(0,0);
        this.props.history.push('/play/'+id);
    }

    handleGoToUser(id){
      window.scrollTo(0,0);
      this.props.history.push('/user/'+id);
    }

    renderSuccesses(successes){
      let ary = [];
      successes.forEach((success, key) => ary.push(
        <Grid.Column key={key} textAlign='center'>
          <Label color={success.color} title={success.text}>
            <Icon name={success.icon} /> {success.headText}
          </Label>
        </Grid.Column>
      ));
      return ary;
    }

    render(){
      
      if(this.state.profile === -1) {
        //return (<Redirect to="/user" />);
        return (
          <DivWrapper>
            <Segment 
              inverted
              textAlign='center'
              style={{ padding: '0em 0em' }}
              vertical
            >
            <Container text style={{padding: '5em 0em'}}>
              <Header
                  as='h1'
                  content='Nutzer nicht gefunden'
                  inverted
                  style={{
                  fontSize: '2em',
                  fontWeight: 'normal',
                  marginBottom: 0,
                  }}
              />
              <Header
                  as='h2'
                  inverted
                  style={{
                  fontSize: '1.5em',
                  fontWeight: 'normal',
                  margin: '1em'
                  }}
              >
                  Der Nutzer hat noch kein Profil erstellt oder es gelöscht
              </Header>
              <Button size='huge' color='green' href='/'>
                  Zu den Hörbüchern
                  <Icon name='right arrow' />
              </Button>
              </Container>
          </Segment>
          </DivWrapper>
        );
      }

      let url = 'https://audory.io/user/';
      if(this.state.profile && this.state.profile.urlShort) url += this.state.profile.urlShort;
      let socialMedia = null;
      if(this.state.profile && this.state.profile.socialMedia) socialMedia = this.getSocialMedia(this.state.profile.socialMedia);
      let date = null;
      if(this.state.profile && this.state.profile.firstStoryDate){
        date = moment(this.state.profile.firstStoryDate).format("DD. MMMM YYYY");
      }
      return (
            <DivWrapper>
            <Segment style={{border: 'none', minHeight: '60vh', marginTop: '2px', borderRadius: 0}}>
                    { this.state.profile ? (
                            <Container>
                              <Segment style={{ padding: '0em' }} vertical>
                                <Divider horizontal style={{marginBottom: '2em'}}>
                                  <Header as='h1'>
                                  {this.state.profile.name}
                                  </Header>
                                </Divider>
                                <Grid container stackable verticalAlign='middle'>
                                  
                                    {
                                      /*
                                      <Grid.Row>
<Header as='h2' style={{ fontSize: '2.5em' }}>
                                      {this.state.profile.name}
                                    </Header>
                                    </Grid.Row>
                                      */
                                    }
                                    
                                    
                                  {
                                    this.state.profile.image && (
                                      <Grid.Row>
                                        <Grid.Column>
                                        <center>
                                          <Image bordered rounded size='medium' src={this.state.profile.image} />
                                        </center>
                                        </Grid.Column>
                                      </Grid.Row>
                                    )
                                  }
                                  {
                                    this.state.profile.description !== '' && (
                                      <Grid.Row>
                                        <Grid.Column textAlign='center'>
                                          <ReadMore
                                            style={{ fontSize: '1.5em', textAlign: 'justify' }}
                                            size={250}
                                            text={this.state.profile.description}
                                          />
                                        </Grid.Column>
                                      </Grid.Row>
                                    )
                                  }
                                  {
                                    this.state.profile.answer !== '' && (
                                      <Grid.Row>
                                        <Grid.Column>
                                          <Header as='h2' style={{ fontSize: '1.5em' }}>
                                            Was ist audory für dich?
                                          </Header>
                                          <ReadMore
                                              style={{ fontSize: '1.4em', textAlign: 'justify' }}
                                              size={250}
                                              text={this.state.profile.answer}
                                            />
                                        </Grid.Column>
                                      </Grid.Row>
                                    )
                                  }
                                  
                                </Grid>
                                {
                                  (socialMedia && Object.keys(socialMedia).length > 0) ? (
                                    <Container>
                                      <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                                        <Header as='h4'>
                                          <Icon name='address card' />
                                          Profile im Netz
                                        </Header>
                                      </Divider>
                                      <Grid container columns={socialMedia.length > 0 ? socialMedia.length : 1} verticalAlign='middle'>
                                        {socialMedia}
                                      </Grid>
                                    </Container>
                                  ) : null
                                }
                                

                                
                                {
                                  this.state.profile.successes.length > 0 && (
                                    <Container>
                                      <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                                        <Header as='h4'>
                                          <Icon name='winner' />
                                          Erfolge
                                        </Header>
                                      </Divider>
                                      <Grid container columns={this.state.profile.successes.length} verticalAlign='middle'>
                                        {this.renderSuccesses(this.state.profile.successes)}
                                      </Grid>
                                    </Container>
                                  )
                                }
                                
                                {
                                  date ? (
                                    <Container>
                                      <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                                        <Header as='h4'>
                                          <Icon name='time' />
                                          Erste Geschichte veröffentlicht am
                                        </Header>
                                      </Divider>
                                      <Grid container columns={1} verticalAlign='middle'>
                                        <Grid.Column textAlign='center'>
                                          <Label color='grey'>
                                            {date}
                                          </Label>
                                        </Grid.Column>
                                      </Grid>
                                    </Container>
                                  ) : null
                                }
                                
                              
                              {
                                this.state.storys.length > 0 ? (
                                  <Container style={{marginTop: '2em'}}>
                                    {
                                    /*<Header as='h3' style={{ fontSize: '2em' }}>
                                      Geschichten
                                    </Header>*/
                                    }
                                    <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                                      <Header as='h2'>
                                        <Icon name='book' />
                                        Geschichten
                                      </Header>
                                    </Divider>
                                    <Item.Group>
                                      {this.renderStorys(this.state.storys)}
                                    </Item.Group>
                                  </Container>
                                ) : (
                                  <Segment style={{marginTop: '2em', minHeight: '100px'}}>
                                    <Dimmer active>
                                      <Loader>Geschichten werden geladen</Loader>
                                    </Dimmer>
                                  </Segment>
                                )
                              }
                              

                              <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                                  <Header as='h4'>
                                    <Icon name='share alternate' />
                                    Profil teilen
                                  </Header>
                                </Divider>
                                <Grid container columns={3} verticalAlign='middle' style={{marginBottom: '2em'}}>
                                  <Grid.Column textAlign='center'>
                                    <WhatsappShareButton url={url}>
                                      <Button icon='whatsapp' color='green' size='big'></Button>
                                    </WhatsappShareButton>
                                  </Grid.Column>
                                  <Grid.Column textAlign='center'>
                                    <TelegramShareButton url={url}>
                                      <Button icon='telegram' color='blue' size='big'></Button>
                                    </TelegramShareButton>
                                  </Grid.Column>
                                  <Grid.Column textAlign='center'>
                                    <FacebookShareButton url={url} >
                                      <Button icon='facebook' color='facebook' size='big'></Button>
                                    </FacebookShareButton>
                                  </Grid.Column>
                                  <Grid.Column textAlign='center'>
                                    <TwitterShareButton url={url} >
                                      <Button icon='twitter' color='twitter' size='big'></Button>
                                    </TwitterShareButton>
                                  </Grid.Column>
                                  <Grid.Column textAlign='center'>
                                    <LinkedinShareButton url={url} >
                                      <Button icon='linkedin' color='linkedin' size='big'></Button>
                                    </LinkedinShareButton>
                                  </Grid.Column>
                                  <Grid.Column textAlign='center'>
                                    <EmailShareButton url={url} >
                                      <Button icon='mail' color='grey' size='big'></Button>
                                    </EmailShareButton>
                                  </Grid.Column>
                                </Grid>
                              </Segment>
                            </Container>
                    ) : (
                        <Dimmer active>
                            <Loader>Profil wird geladen...</Loader>
                        </Dimmer>
                    )
                    }
            </Segment>
            </DivWrapper>
        );
    }
} 


export default UserPage;


// WEBPACK FOOTER //
// ./src/components/UserPage.js